import { useStore } from "@/store";
import { getVisiblePartners } from "./selectors";

export const getPartners = () => {
  const partners = useStore.getState().advizeApiData.partners;
  return getVisiblePartners(partners || []);
};
